module.exports = __webpack_public_path__ + "static/media/mitigation.b380d4be.png";